import { useContext } from 'react'
import { TemplateContext } from '../context'

export const useISAContext = () => {
  const { ISA } = useContext(TemplateContext)

  return ISA
}
